import ExpertLayout from '@/layouts/ExpertLayout';
import ExpertIndex from '@/views/expert/Index';
import ExpertMailBox from '@/views/expert/MailBox';

const routes = [
  {
    path: '/expert',
    component: ExpertLayout,
    meta: {
      requiresAuth: true,
      isChuyenGia: true,
      title: "Chuyên gia"
    },
    children: [
      {
        path: '',
        name: 'ExpertIndex',
        component: ExpertIndex
      },
      {
        path: 'mail-box',
        name: 'ExpertMailBox',
        component: ExpertMailBox
      }
    ]
  }
];

export default routes;